import React from 'react';


import { Switch, Route } from "react-router-dom";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/VerticalLayouts";

// Routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected, AccessRoute } from './AuthProtected';

const Index = () => {
  return (
    <React.Fragment>
      <Switch>
        {/* Public Routes */}
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            exact
            render={props => (
              <NonAuthLayout>
                <route.component {...props} />
              </NonAuthLayout>
            )}
          />
        ))}

        {/* Auth Protected Routes */}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            exact
            render={props => (
              <AuthProtected>
                <VerticalLayout>
                  <AccessRoute component={route.component} {...props} />
                </VerticalLayout>
              </AuthProtected>
            )}
          />
        ))}
      </Switch>
    </React.Fragment>
  );
};

export default Index;